// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import HealthFacilities__AssessmentFillController from "./health_facilities/assessment_fill_controller"
application.register("health-facilities--assessment-fill", HealthFacilities__AssessmentFillController)

import HealthFacilities__PatientSyncController from "./health_facilities/patient_sync_controller"
application.register("health-facilities--patient-sync", HealthFacilities__PatientSyncController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)
